const angular = require('angular')
const changePasswordCtrl = require('./changePasswordCtrl')
const changePasswordService = require('./changePasswordService')

module.exports = angular
  .module('hxphone.changePassword', [])
  .factory('changePasswordService', changePasswordService)
  .controller('changePasswordCtrl', changePasswordCtrl)



// WEBPACK FOOTER //
// ./src/js/setting/changePassword/module.js